import { api } from './client'

export interface UserNotification {
  id: number
  type: string
  title_ru: string
  title_uz: string
  body_ru: string
  body_uz: string
  emoji: string
  related_order_id: number | null
  related_payment_id: number | null
  is_read: boolean
  created_at: string
}

export async function getUserNotifications(limit = 20, offset = 0): Promise<UserNotification[]> {
  const res = await api.get('/api/v1/users/me/notifications', { params: { limit, offset } })
  return res.data
}

export async function markAllNotificationsRead(): Promise<void> {
  await api.post('/api/v1/users/me/notifications/read-all')
}
